import { useEffect } from "react";
import * as Styles from "./style";
import { Header } from "~/components/blocks/layout/global-navi/mobile/left/dmm-service/header";
import { MenuList } from "~/components/blocks/layout/global-navi/mobile/left/dmm-service/menu-list";

type DmmServiceMobileProps = {
  isShowDmmService: boolean;
  onToggleDmmService: () => void;
};

export const DmmServiceMobile = (props: DmmServiceMobileProps) => {
  const { isShowDmmService } = props;

  const scrollLock = () => {
    const bodyElement = document.body;
    bodyElement.style.overflow = "hidden";

    return () => {
      bodyElement.style.overflow = "";
    };
  };
  useEffect(scrollLock, [isShowDmmService]);

  return (
    <Styles.DivContainer isVisible={isShowDmmService}>
      <Header />
      <MenuList />
    </Styles.DivContainer>
  );
};
